export default defineNuxtRouteMiddleware((to, from) => {
    if (process.client) {
        const { isLogin } = useAuthStore()
        if (!isLogin) {
          const localePath = useLocalePath()
          return navigateTo(localePath('/login'))
        }
      }
})
